import { render, staticRenderFns } from "./FhNumber.vue?vue&type=template&id=ecc20df2&scoped=true&"
import script from "./FhNumber.vue?vue&type=script&lang=js&"
export * from "./FhNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc20df2",
  null
  
)

export default component.exports